import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const TableSkeletonSession = () => {
  return (
    <Box className={styles['table-skeleton__container']} data-testid="table-skeleton__container-session">
      <Table className={styles['table__skeleton']}>
        <Thead>
          <Tr>
            <Th className={styles['skeleton__head']} minWidth="233px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="235px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="177px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="60%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="158px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="70%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="131px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="70%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="156px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="235px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="168px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="219px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="207px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="167px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="221px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="127px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="201px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>

            <Th className={styles['skeleton__head']} minWidth="127px">
              <Flex justifyContent="space-between">
                <SkeletonComponent height="18px" width="50%" />
                <SkeletonComponent height="18px" width="18px" />
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Iteration
            items={[1, 2, 3, 4, 5, 6, 7, 8]}
            render={(num) => {
              return (
                <Tr key={num}>
                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>
                </Tr>
              );
            }}
          />
        </Tbody>
      </Table>
    </Box>
  );
};

export default TableSkeletonSession;
